import { render, staticRenderFns } from "./chart-data.vue?vue&type=template&id=18d57bb2&"
import script from "./chart-data.vue?vue&type=script&lang=js&"
export * from "./chart-data.vue?vue&type=script&lang=js&"
import style0 from "./chart-data.vue?vue&type=style&index=0&id=18d57bb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports